import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { captureException } from '@sentry/browser';

const getGraphqlEndpoint = (): string => {
    if (typeof window !== 'undefined' && window.config?.GRAPHQL_ENDPOINT) {
        return window.config.GRAPHQL_ENDPOINT;
    }
    return '';
};

const httpLink = new HttpLink({ uri: getGraphqlEndpoint() });

const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
        graphQLErrors.forEach(({ message, locations, path }) => {
            captureException(new Error(`GraphQL error: Message: ${message}, Location: ${locations}, Path: ${path}`));
        });
    }

    if (networkError) {
        captureException(new Error(`GraphQL network error: ${networkError}`));
    }
});

const client = new ApolloClient({
    link: ApolloLink.from([errorLink, httpLink]),
    cache: new InMemoryCache({
        possibleTypes: {
            GQLPaymentOptions: ['GQLRatingOutcomeSinglePaymentOption', 'GQLRatingOutcomeInstalmentsPaymentOption'],
        },
    }),
});

export default client;
